var _excluded = ["active", "children", "classes", "disabled", "liRef", "onClick"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../../styles.css";
var BaseListItem = function BaseListItem(_ref) {
  var active = _ref.active,
    children = _ref.children,
    classes = _ref.classes,
    disabled = _ref.disabled,
    liRef = _ref.liRef,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  var itemClass = classes.item;
  if (active) itemClass = classes['item-is-active'];
  if (disabled) itemClass = classes['item-is-disabled'];
  return /*#__PURE__*/React.createElement("li", _extends({}, rest, {
    className: itemClass,
    ref: liRef,
    role: "option",
    "aria-selected": "false",
    onClick: !disabled && onClick ? onClick : null
  }), children);
};
process.env.NODE_ENV !== "production" ? BaseListItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  liRef: PropTypes.func,
  onClick: PropTypes.func,
  classes: classesPropType(['container', 'is-open', 'list-container', 'list', 'item', 'item-is-disabled', 'item-is-active'])
} : void 0;
export default withClasses(styles)(BaseListItem);